/**
 * This file was auto-generated by scripts/generate-pagination-paths.ts
 * Do not make direct changes to the file.
 */

export const CURSOR_PATHS = ["/me/bible/saves"] as const;

export const CURSOR_PATHS_SET = new Set<string>(CURSOR_PATHS);
